import React, { FunctionComponent, ReactNode } from 'react';
import { useValidateAuth, useInitUserLanguage, useAuthTokenSync } from './hooks';

export interface AuthLayerProps {
  children: ReactNode;
}

const AuthLayer: FunctionComponent<AuthLayerProps> = ({ children }) => {
  const { authIsVerified, currentUser } = useValidateAuth();
  useInitUserLanguage(currentUser);

  useAuthTokenSync();

  // todo: initial loading page
  if (!authIsVerified) return null;

  return <>{children}</>;
};

export default AuthLayer;
